// extracted by mini-css-extract-plugin
export default {"commentPopoutContainer":"styles_commentPopoutContainer__YGqLa","header":"styles_header__xxcxx","content":"styles_content__pDN0-"};